import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDataModel, extend } from '@thd-nucleus/data-sources';
import { SkeletonBlock } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { dataModel } from '../dataModel';
import { SpecificationGroupContent } from '../component/SpecificationGroupContent';

export const SingleSpecificationsWithKPFComponent = (props) => {
  const {
    itemId,
    oneColumn,
    returnableStatus,
    isWhiteSpecTitle,
    isConfigurableProduct,
  } = props;
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const { data, loading } = useDataModel('product', { skip: !itemId, variables: { itemId } });

  if (loading) {
    return (
      <div
        className="sui-w-full"
        data-component="SingleSpecificationsPlaceholder"
      >
        <SkeletonBlock aspect="wide" height={52} width="100%" />
      </div>
    );
  }
  if (!data || !data?.product?.specificationGroup) {
    return null;
  }

  const { specificationGroup } = data.product;

  return (
    <div
      className="sui-flex sui-flex-wrap sui-w-full sui-box-border
      sui-pointer-events-auto sui-gap-6"
      id="specifications"
      data-component="SpecificationsHDHPIPAccordionBody"
    >
      <KeyProductFeatures
        itemId={itemId}
        maxfeatures={8}
        minfeatures={isMobile ? 4 : 3}
        channel={channel}
        displaySimilarLinks
        twoColumnGrid={isMobile}
        isConfigurableProduct={isConfigurableProduct}
      />
      <SpecificationGroupContent
        specificationGroup={specificationGroup}
        oneColumn={oneColumn}
        returnableStatus={returnableStatus}
        isWhiteSpecTitle={isWhiteSpecTitle}
      />
    </div>
  );
};

SingleSpecificationsWithKPFComponent.displayName = 'SingleSpecificationsWithKPFComponent';
SingleSpecificationsWithKPFComponent.dataModel = extend({}, dataModel, KeyProductFeatures);

const propTypes = {
  /** SKU Number */
  itemId: PropTypes.string.isRequired,
  returnableStatus: PropTypes.bool,
  oneColumn: PropTypes.bool,
  isWhiteSpecTitle: PropTypes.bool,
  isConfigurableProduct: PropTypes.bool,
};

const defaultProps = {
  oneColumn: false,
  returnableStatus: false,
  isWhiteSpecTitle: false,
  isConfigurableProduct: false,
};

SingleSpecificationsWithKPFComponent.propTypes = propTypes;
SingleSpecificationsWithKPFComponent.defaultProps = defaultProps;

export const SingleSpecificationsWithKPF = withErrorBoundary(SingleSpecificationsWithKPFComponent);

SingleSpecificationsWithKPF.dataModel = extend({}, dataModel, KeyProductFeatures);
SingleSpecificationsWithKPF.propTypes = propTypes;
SingleSpecificationsWithKPF.defaultProps = defaultProps;
